var map = {
	"./blog-details.png": 3564,
	"./blog-grid.png": 7851,
	"./blog-two-column.png": 4637,
	"./hero-bg.jpg": 3921,
	"./home-01.png": 4351,
	"./home-02.png": 6035,
	"./logo-2.png": 8297,
	"./logo.png": 4129
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9864;